<div class="flex flex-col">
  @if(headerBlock) {
  <div class="flex w-full">
    <ng-template [ngTemplateOutlet]="headerBlock || defaultHeaderBlock"></ng-template>
  </div>
  }
  <div>
    <div id="content" (scrollend)="scrollEnd()">
      @if(loading) {
      <ng-template [ngTemplateOutlet]="loadingBlock || defaultLoading"></ng-template>
      } @if(items.size > 0) {
      <ng-template [ngTemplateOutlet]="itemList"></ng-template>
      } @if(emptyItemsBlock && items.size <= 0 && !loading) {
      <ng-template [ngTemplateOutlet]="emptyItemsBlock"></ng-template>
      }
      <div #footerContainer>
        @if(footerBlock) {
        <ng-template [ngTemplateOutlet]="footerBlock || defaultFooterBlock"></ng-template>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #defaultLoading>
  <gx-loader></gx-loader>
</ng-template>

<ng-template #itemList>
  <nav aria-label="Directory">
    <div class="list-group">
      @for(letter of groupLetters; track $index) { @if(!loading) {
      <div class="list-title" [id]="letter">
        <ng-container
          [ngTemplateOutlet]="groupBlock || defaultGroupBlock"
          [ngTemplateOutletContext]="{$implicit: letter, letter}" />
      </div>
      }
      <ul role="list" class="list">
        @if(!loading) { @for(item of getItemsForLetter(letter); track $index) {
        <ng-container
          [ngTemplateOutlet]="itemBlock || defaultItemBlock"
          [ngTemplateOutletContext]="{ $implicit: item, item}" />
        } }
      </ul>
      }
    </div>
  </nav>
</ng-template>

<ng-template #defaultItemBlock let-item>
  <pre title="default item block!">
    {{ item | json }}
  </pre>
</ng-template>

<ng-template #defaultGroupBlock let-letter>
  <pre title="default group block!">
    {{ letter }}
  </pre>
</ng-template>

<ng-template #defaultHeaderBlock> </ng-template>

<ng-template #defaultFooterBlock> </ng-template>
